import type { PersonInvolvementKind } from "../types/involvement.js";

// A total `Record`, so admitting a kind without deciding what it excludes
// does not compile.
const excludedInvolvementKindByKind: Record<
  PersonInvolvementKind,
  PersonInvolvementKind | undefined
> = {
  created_by: undefined,
  duty_of_care: undefined,
  placement: undefined,
  responsible_user: undefined,
  designated_assessor: "approver",
  assessor: undefined,
  viewer: undefined,
  approver: "designated_assessor",
  shared_assessment_reader: undefined,
};

/**
 * The involvement kind a user may not hold alongside this one for the same
 * person: an approval by the user whose work it is is not an approval, and an
 * approver exists for no other reason.
 */
export const involvementKindExcludedBy = (
  kind: PersonInvolvementKind,
): PersonInvolvementKind | undefined => excludedInvolvementKindByKind[kind];
